import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";

const links = [
  { label: "Módulos", href: "#modulos" },
  { label: "Talos · IA", href: "#talos" },
  { label: "IA nos Fluxos", href: "#ia-embutida" },
  { label: "Telas do App", href: "#showcase" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Planos", href: "#planos" },
  { label: "FAQ", href: "#faq" },
];

const AUTH_URL = "https://app.muft.space/auth/login";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-40"
      data-testid="navbar"
    >
      <div
        className={`mx-auto mt-3 flex max-w-7xl items-center justify-between rounded-full px-5 py-3 transition-[background-color,box-shadow,border-color] duration-500 md:px-6 ${
          scrolled
            ? "border border-white/10 bg-navy-800/85 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)] backdrop-blur-xl"
            : "border border-transparent bg-transparent"
        } mx-4 md:mx-auto`}
      >
        <a href="#top" aria-label="MUFT" data-testid="nav-logo-link">
          <Logo />
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-semibold text-white/70 transition-colors duration-300 hover:text-white"
              data-testid={`nav-link-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            href={AUTH_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-login-button"
            className="rounded-full border border-white/20 bg-white/5 px-4 py-2 text-xs font-bold text-white transition-all duration-300 hover:border-white/40 hover:bg-white/10"
          >
            Acessar
          </a>
          <ThemeToggle />
          <a
            href={AUTH_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-trial-button"
            className="hidden rounded-full bg-white px-5 py-2.5 text-xs font-bold text-navy-800 shadow-md transition-all duration-300 hover:bg-lavender hover:scale-105 sm:inline-flex"
          >
            Cadastre-se
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
